import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 32px repeat(10, 1fr) 32px;
  margin-bottom: 20px;
  margin-top: 40px;

  @media ${DEVICE.tabletL} {
    grid-template-columns: 1fr repeat(10, 1fr) 1fr;
    margin-bottom: 40px;
    margin-top: 60px;
    max-width: 1317px;
  }
`

export const Content = styled.div`
  align-items: center;
  border-bottom: 1px solid var(--content-background-dark-blue);
  border-top: 1px solid var(--content-background-dark-blue);
  display: flex;
  grid-column: 2 / 12;
  justify-content: space-between;
  padding: 15px 0;

  @media ${DEVICE.tabletL} {
    justify-content: center;
    padding: 27px 0;
  }
`

export const Title = styled.h5`
  color: var(--content-background-dark-blue);
  display: block;
  font-size: 1.6rem;
  line-height: 1.357;

  @media ${DEVICE.tabletL} {
    font-size: 2rem;
    margin-right: 30px;
  }
`

export const ShareIcon = styled.button`
  background: none;
  color: var(--highlight-blue);
  display: block;
  height: 32px;
  outline: none;
  width: 32px;

  > svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  &:hover {
    color: var(--content-background-dark-blue);
  }

  @media ${DEVICE.tabletL} {
    height: 46px;
    margin: 0 30px;
    width: 46px;
  }
`

export const ShareIconLink = styled.a`
  color: var(--highlight-blue);
  display: block;
  height: 32px;
  width: 32px;

  > svg {
    display: block;
    height: 100%;
    width: 100%;
  }

  &:hover {
    color: var(--content-background-dark-blue);
  }

  @media ${DEVICE.tabletL} {
    height: 46px;
    margin: 0 30px;
    width: 46px;
  }
`
